/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit TysiaIconWait/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function TysiaIconWait({
  children,
  viewPath = "/DesignSystem/Svgs/TysiaIconWait",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#9AA5B1",
  fill3 = "#fff"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="TysiaIconWait.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-JQ3E': alignSelf,'--mt-2-JQ3E': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-JQ3E': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-JQ3E': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-JQ3E': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-JQ3E': opacity,'--w-10-JQ3E': typeof width === 'number' ? `${width}px` : width,'--h-11-JQ3E': typeof height === 'number' ? `${height}px` : height,'--f-12-JQ3E': fill,'--a-7-JQ3E': isAnimated ? animation : "none",'--sd-8-JQ3E': isAnimated ? strokeDashoffset : 0,'--sd-9-JQ3E': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<rect
  data-testid="TysiaIconWait.SvgRect"
  data-view-path={viewPath}
 rx={2}
 style={{'--f-12-JQ3E': fill2}}
 className={`views-block ${styles.SvgRect}`}
/>
<path
  data-testid="TysiaIconWait.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M8.603 6.412a.75.75 0 10-.706-1.324 9.44 9.44 0 00-2.715 2.173.75.75 0 101.136.978 7.94 7.94 0 012.285-1.827zM12 19a6 6 0 100-12 6 6 0 000 12zm3.088-13.602a.75.75 0 011.014-.31 9.44 9.44 0 012.716 2.173.75.75 0 01-1.137.978 7.94 7.94 0 00-2.284-1.827.75.75 0 01-.309-1.014zM12.625 10a.625.625 0 10-1.25 0v3c0 .345.28.625.625.625h2.5a.625.625 0 000-1.25h-1.875V10z"
 style={{'--f-12-JQ3E': fill3}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}